export default ({ yAxisFormatter }: FixmeType) => {
    return {
        yAxis: {
            labels: {
                formatter: function () {
                    return yAxisFormatter(this);
                },
            },
        },
    };
};
